import React from 'react';
import PropTypes from 'prop-types';
import {withStyles} from '@material-ui/core/styles';
import makeStyles from "@material-ui/core/styles/makeStyles";
import FieldScreenComponent from "../FieldScreenComponent";
import LabelScreenComponent from "../LabelScreenComponent";
import AddArrayButton from "../AddArrayButton";
import TableFields from "../TableFields/TableFields";
import FieldsInfinity from "../FieldsInfinity";
import findByString from "../../../../../Utils/Form/FormDynamic/Utils/getValueByString";
import JsonScreenHoc from "../../../../../HocHelpers/JsonScreenHoc";
import {useContextMenu} from "../../../../../Hooks";
import ForEachComponent from "../ForEachComponent/ForEachComponent";
import {getParamsFromString} from "../../../Utils";

const styles = () => ({
    groupWrapper: {
        position: 'relative',
        minHeight: '40px',
    },
    fieldsWrapper: {marginLeft: 20},
    menuItem: {
        padding: "0px 3px",
        minWidth: 300,
    },
    shortCutName: {
        marginLeft: 'auto'
    },
});

const ContainerArrayFields = (props) => {
    const {
        element, arrayPath, fieldErrors, globalValues, screenName,
        addGroup, removeGroup, actionsContext, containerArrayPath
    } = props;
    const {onOpen, ContextMenu} = useContextMenu({
        addBefore: actionsContext.addRecord ? actionsContext.addRecord : addGroup,
        addAfter: actionsContext.addRecord ? actionsContext.addRecord : addGroup,
        remove: removeGroup,
        editRecord: actionsContext.editRecord,
        isEntityMixed: actionsContext.isEntityMixed
    });
    let elementPath = arrayPath ? `${arrayPath}.${element.properties.name}` : element.properties.path;
    const arrayType = element.properties.arrayType || 'vertical';
    const values = findByString(globalValues.param[screenName], elementPath) || [{}];
    const previewMode = getParamsFromString('{inParam.previewMode}', globalValues, screenName) === 'true';
    function onOpenContext(e, currentPath, arrayPath, index, disabled = {}) {
        onOpen(e, currentPath, arrayPath, index, disabled)
    }

    return (
        arrayType === 'horizontal' ? (
            <TableFields
                element={element}
                elementPath={elementPath}
                arrayPath={arrayPath}
                actionsContext={actionsContext}
                containerArrayPath={containerArrayPath}
            />
        ) : (
            <>
                <VerticalArrayFields
                    values={values}
                    globalValues={globalValues}
                    errors={fieldErrors}
                    arrayPath={arrayPath}
                    element={element}
                    openContextMenu={onOpenContext}
                    previewMode={previewMode}
                    actionsContext={actionsContext}
                />
                <ContextMenu/>
            </>
        )
    )
};

const useVerticalArrayStyles = makeStyles(() => ({
    fieldsWrapper: {marginLeft: 20},
    groupWrapper: {
        position: 'relative',
        minHeight: '40px',
        width: '100%'
    },
}));
const VerticalArrayFields = (props) => {
    const {values, errors, arrayPath, element, openContextMenu, previewMode, globalValues, actionsContext} = props;
    const classes = useVerticalArrayStyles();
    const {properties: {allowCreate, allowDelete}} = element;
    let isCreatable = allowCreate === true || allowCreate === undefined;
    let isRemovable = allowDelete === true || allowDelete === undefined;
    function verticalFields(element, index, values) {
        let elementPath = arrayPath ? arrayPath : element.properties.path;
        let newPath = `${elementPath}.${index}`;

        return (
            <div className={classes.groupWrapper}>
                <AddArrayButton
                    valueIndex={index}
                    path={elementPath}
                    previewMode={previewMode}
                    openGroupMenu={(e) => openContextMenu(e, newPath, elementPath, index, {
                        after: !Boolean(isCreatable),
                        before: !Boolean(isCreatable),
                        remove: !Boolean(isRemovable) || (index === 0 && values.length === 1)
                    })}
                />
                <div className={classes.fieldsWrapper}>
                    {(element.children || []).map((field, indexVal) => {
                        return (
                            field.type === 'field' ? (
                                renderField(newPath, indexVal, values, index, element, field, previewMode)
                            ) : field.type === 'label' ? (
                                <LabelScreenComponent element={field}/>
                            ) : field.type === 'fieldArray' ? (
                                renderFieldArray(newPath, indexVal, field, globalValues, actionsContext)
                            ) : field.type === 'fieldInfinity' ? (
                                renderFieldInfinity(newPath, indexVal, field, element.children)
                            ) : field.type === 'forEach' ? (
                                <ForEachComponent
                                    component={field}
                                    containerArrayPath={newPath}

                                />
                            ) :
                                null
                        );
                    })}
                </div>
            </div>
        )
    }

    const renderField = (newPath, indexVal, values, valueIndex, element, field, previewMode) => {
        let fieldPath = `${newPath}.${field.properties.path}`;
        let isRender = previewMode ? Boolean(findByString(values, valueIndex + "." + field.properties.name)) : true;
        let isDisabled = previewMode ? previewMode : field.properties.disabled;
        return (
            <React.Fragment key={`${newPath}.${field.properties.name}.${indexVal}`}>
                {isRender&&(<FieldScreenComponent
                    globalValues={values}
                    fieldErrors={errors}
                    field={{...field, properties: {...field.properties, path: fieldPath, disabled: isDisabled}}}
                />)}
            </React.Fragment>
        )
    };

    const renderFieldArray = (newPath, indexVal, field, globalValues, actionsContext) => {
        let newNestedPath = field.properties.path.split('.');
        return (
            <React.Fragment key={`${newPath}.${newNestedPath.join('.')}`}>
                <ContainerArrayFields
                    arrayPath={`${newPath}.${field.name}`}
                    index={indexVal}
                    element={field}
                    globalValues={globalValues}
                    actionsContext={actionsContext}
                />
            </React.Fragment>
        )
    };

    const renderFieldInfinity = (newPath, indexVal, field, parent) => {
        let newNestedPath = field.properties.path.split('.');
        newNestedPath.shift();
        return (
            <React.Fragment key={`${newPath}.${newNestedPath.join('.')}`}>
                <FieldsInfinity
                    arrayIndex={indexVal}
                    element={{
                        ...field,
                        properties: {
                            ...field.properties,
                            path: `${newPath}.${newNestedPath.join('.')}`,
                            parentSchema: parent,
                        }
                    }}
                />
            </React.Fragment>
        )
    };

    return (
        values.map((value, index) => (
            <React.Fragment key={index}>
                {verticalFields(element, index, values)}
            </React.Fragment>
        ))
    )
};

export default JsonScreenHoc(withStyles(styles)(ContainerArrayFields));

ContainerArrayFields.propTypes = {
    element: PropTypes.object,
    arrayPath: PropTypes.string, //coming from nested array
    previewMode: PropTypes.bool,
};

ContainerArrayFields.defaultProps = {
    actionsContext: {}
};
